import z from 'zod'

import { emailSchema, entitySchema } from '@/utility'

/**
 * Banned users is a platform-wide feature that prevents
 * users with a specific email from creating new accounts,
 * teams or logging in altogether
 *
 * We require a banning reason and team member email for
 * auditing purposes
 */
export const bannedUserSchema = entitySchema
  .extend({
    email: emailSchema,
    reason: z.string(),
    bannedBy: emailSchema,
  })
  .meta({ id: 'banned-user' })
